const getImageFromAssets = (assets: any, imageName: string) =>
  assets.edges.find(({ node: { name } }: { node: any }) => name === imageName).node;

export default getImageFromAssets;
